import { render } from "./side_drawer.vue?vue&type=template&id=507354d3"
import script from "./side_drawer.js?vue&type=script&lang=js"
export * from "./side_drawer.js?vue&type=script&lang=js"

import "./side_drawer.vue?vue&type=style&index=0&id=507354d3&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__